module.exports = require('./build/react')



//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/react.js
// module id = 80
// module chunks = 0